export const getImageSize = (image, size, defaultImage) => {
  if (image && image.sizes && image.sizes[size] && image.sizes[size].url) {
    return image.sizes[size].url;
  }
  return defaultImage ? `/img/${defaultImage}` : `/img/no-image.png`;
};
